import { type PartialDeep } from 'type-fest';

import {
  type PropertiesConfigInputVisualEffectModel,
  type VisibilityAccessRoleRef,
} from '@blaze-shared/elements-domain';
import { mergeDefinedIntoArray } from '@blaze-shared/shared-util';

import {
  extractActionsPageRefs,
  extractElementActionWorkflowsRefs,
} from '../../canvas-elements/element-model/props-extractor';
import { PropsExtractor } from '../__base/props-extractor';

export class CalendarPropsExtractor extends PropsExtractor<'calendar'> {
  override getPageReferences: () => string[] = () => {
    if (!this.props?.content) {
      return [];
    }
    return extractActionsPageRefs(this.props.content);
  };

  override getVisualEffect: () => PartialDeep<PropertiesConfigInputVisualEffectModel> | undefined =
    () => this.props?.style?.general?.visualEffect;

  override getVisibilityAccessRolesRefs(): VisibilityAccessRoleRef[] {
    return mergeDefinedIntoArray(
      ...super.getVisibilityAccessRolesRefs(),
      ...extractElementActionWorkflowsRefs(this.props?.content, {
        allowUndefinedTargetTypeForItemDelete: true,
      }),
    );
  }
}
